export const fitting = `
[Tengu, Tengu - Logistics + Command]
Power Diagnostic System II
Power Diagnostic System II
Power Diagnostic System II
Power Diagnostic System II

Large Shield Extender II
Multispectrum Shield Hardener II
EM Shield Hardener II
10MN Afterburner II
Thukker Large Cap Battery
Thukker Large Cap Battery

Shield Command Burst II
Shield Command Burst II
Medium Remote Shield Booster II
Medium Remote Shield Booster II
Medium Remote Shield Booster II
Medium Remote Shield Booster II
Medium Remote Capacitor Transmitter II

Medium Command Processor I
Medium Capacitor Control Circuit I
Medium Ancillary Current Router II

Tengu Core - Augmented Graviton Reactor
Tengu Defensive - Supplemental Screening
Tengu Offensive - Support Processor
Tengu Propulsion - Fuel Catalyst

Warrior II x5
Hornet EC-300 x5

Shield Extension Charge x600
Nanite Repair Paste x200
Active Shielding Charge x600
Shield Harmonizing Charge x600
`
